





























































import { Component, Vue, Prop } from 'vue-property-decorator';

import { DataBus, TireStoringContract, Term, ResponseCodeEnum } from '@/models';
import { toastService, tireStoringContractService } from '@/services';

@Component
export default class TireConfirmTerm extends Vue {
  @Prop() public tireContract!: TireStoringContract;
  private isSendEmail: boolean = false;
  private term: Term = new Term();
  private status: boolean = false;
  private click: number = 0;

  private options = {
    backgroundColor: 'rgb(255, 255, 255)',
    penColor: 'black',
  };

  private created() {
    tireStoringContractService.getTerm()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.term = res.data.data;
        }
      });
  }

  private cancelRegister() {
    this.$emit('loadComponent', new DataBus({
      event: 'cancel_register',
    }));
  }

  private undoPad() {
    (this.$refs.signaturePad as any).undoSignature();
  }

  private clearPad() {
    (this.$refs.signaturePad as any).clearSignature();
  }
  
  private goBack() {
    this.$emit('loadComponent', new DataBus({
      event: 'confirm_info',
    }));
  }

  private saveContract() {
    const signData = (this.$refs.signaturePad as any).saveSignature();
    this.click++;
    // Check Double-click
    if (this.click === 1) {
      if (!this.status) {
        if (signData.isEmpty) {
          toastService.errorMessage('view.tire_confirm.tire_signature.message.required');
          this.click--;
          return;
        }
      }
      this.tireContract.signatureImageBase64 = !signData.isEmpty ? signData.data.split(',').pop() : null;
      this.$emit('loadComponent', new DataBus({
        event: 'save',
        data: this.isSendEmail,
      }));
    }
  }

}
